module.exports = __webpack_public_path__ + "static/clickmap2-9fb326286f324f1c29e26dd00bfad306.png";